import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ResponsiveContainer,
} from "recharts";

const MonthlyLineChartGraph = ({
    data,
    xTicks = [],
    yTicks = [],
    yFormatter = (v) => v,
    color = "#0b6775",
    height = 220,
}) => {
    const displayData = Array.isArray(data) ? data : [];

    if (!displayData.length) {
        return (
            <div
                style={{
                    width: "100%",
                    height,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#777",
                    fontSize: "14px",
                }}
            >
                No hay datos disponibles
            </div>
        );
    }

    const dataMaxValue = displayData.reduce(
        (max, d) => Math.max(max, Number(d.value) || 0),
        0
    );
    const maxY = yTicks.length
        ? Math.max(...yTicks, dataMaxValue)
        : dataMaxValue;
    const hasYTicks = yTicks.length > 0;

    return (
        <div style={{ width: "100%", height, position: "relative" }}>
            <ResponsiveContainer width="100%" height="100%">
                <LineChart
                    data={displayData}
                    margin={{ top: 10, right: 10, left: 5, bottom: 5 }}
                >
                    <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
                    <XAxis
                        dataKey="name"
                        ticks={xTicks.length ? xTicks : undefined}
                        tick={{ fontSize: 11, fill: "#666" }}
                        axisLine={false}
                        tickLine={false}
                        interval="preserveStartEnd"
                    />
                    <YAxis
                        type="number"
                        domain={hasYTicks ? [0, maxY] : [0, dataMaxValue]}
                        ticks={hasYTicks ? yTicks : undefined}
                        tickFormatter={yFormatter}
                        tick={{ fontSize: 11, fill: "#666" }}
                        axisLine={false}
                        tickLine={false}
                        width={55}
                    />
                    <Tooltip
                        contentStyle={{
                            backgroundColor: "#fff",
                            border: "none",
                            borderRadius: "8px",
                            boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                            fontSize: "14px",
                        }}
                        labelStyle={{
                            fontSize: "14px",
                            fontWeight: "600",
                            color: "#333",
                        }}
                    />
                    <Line
                        type="monotone"
                        dataKey="value"
                        name="tn"
                        stroke={color}
                        strokeWidth={2}
                        dot={{ r: 3 }}
                        activeDot={{ r: 6 }}
                    />
                </LineChart>
            </ResponsiveContainer>
        </div>
    );
};

export default MonthlyLineChartGraph;
